import { render, staticRenderFns } from "./StatisticsPrograms.vue?vue&type=template&id=3fe0a98e&"
import script from "./StatisticsPrograms.vue?vue&type=script&lang=js&"
export * from "./StatisticsPrograms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports